"use client";

import {
	TransitionControl as DialKitVendorTransition,
	type TransitionConfig,
} from "dialkit";
import { cn } from "../../../lib";
import { DialKitEmbeddedHost } from "./dialkit-embedded-host";
import "./dialkit-styles";

export type DialKitEasingValue = TransitionConfig;

export interface DialKitEasingProps {
	label: string;
	value: DialKitEasingValue;
	onChange: (value: DialKitEasingValue) => void;
	/** Stable id for DialKit TransitionControl panel path. */
	panelId?: string;
	path?: string;
	hideDuration?: boolean;
	disabled?: boolean;
	className?: string;
}

/**
 * Prefer-over DialKit TransitionControl (Easing + Spring modes).
 */
export function DialKitEasing({
	label,
	value,
	onChange,
	panelId = "sq-easing",
	path = "easing",
	hideDuration = true,
	disabled = false,
	className,
}: DialKitEasingProps) {
	return (
		<DialKitEmbeddedHost
			data-dialkit-easing=""
			className={cn(
				disabled && "pointer-events-none opacity-50",
				className,
			)}
		>
			<DialKitVendorTransition
				panelId={panelId}
				path={path}
				label={label}
				value={value}
				onChange={onChange}
				hideDuration={hideDuration}
			/>
		</DialKitEmbeddedHost>
	);
}
